import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_iuf_select = _resolveComponent("iuf-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: "text-body2",
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_iuf_select, _mergeProps({
      options: _ctx.valueOptions,
      "option-label": "label",
      "option-value": "value"
    }, _ctx.SELECT_SINGLE_LG, {
      modelValue: _ctx.infoGroupBooleanFilter,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.infoGroupBooleanFilter) = $event))
    }), null, 16, ["options", "modelValue"])
  ]))
}